import React from "react";
import tickIcon from "../../../../assets/img/tickIcon.svg";
import activeCurrency from "../../../../assets/img/active-currency.svg";
import inactiveCurrency from "../../../../assets/img/inactive-currency.svg";

function PriceCard({ isActive = true, monthly = false }) {
  const selectedLanguage = localStorage.getItem("language");
  const subscribedPoints = [
    {
      label: selectedLanguage === "arabic" ? "عدد غير محدود من المستخدمين" : "Unlimited nusers",
    },
    {
      label: selectedLanguage === "arabic" ? "تحكم متقدم للأدوار والصلاحيات." : "Advanced control of roles and permissions.",
    },
    {
      label: selectedLanguage === "arabic" ? "تتبع مبيعات المستخدمين." : "Track user sales.",
    },
  ];
  const freePoints = [
    {
      label: selectedLanguage === "arabic" ? "مستخدم واحد." : "Single user.",
    },
    {
      label: selectedLanguage === "arabic" ? "عدد غير محدود من المتاجر." : "Unlimited stores.",
    },
    {
      label: selectedLanguage === "arabic" ? "عدد غير محدود من نقاط البيع." : "Unlimited  points of sale.",
    },
    {
      label: selectedLanguage === "arabic" ? "عدد غير محدود من المنتجات." : "Unlimited products.",
    },
    {
      label: selectedLanguage === "arabic" ? "تحليلات وتقارير لحظيه." : "Real-time analytics and reports.",
    },
    {
      label: selectedLanguage === "arabic" ? "اضافة علامتك التجارية على فواتيرك." : "Add your brand to your invoices.",
    },
  ];
  const translateText = (text) => {
    if (selectedLanguage === "arabic") {
      return text === "Basic Service (Free)"
        ? "الخدمة الأساسية (مجانية)"
        : text === "User Management Service"
        ? "خدمة إدارة المستخدمين"
        : text === "Suitable for small and medium enterprises."
        ? "مناسب للمنشآت الصغيرة والمتوسطة."
        : text === "Suitable for micro-enterprises."
        ? "مناسب للمنشآت متناهية الصغر."
        : text === "per user, per month"
        ? "للمستخدم، بالشهر"
        : text === "per user, per year"
         ? "للمستخدم، بالسنة"
        : text === "Includes all the benefits of the basic service, in addition:"
        ? "تشمل جميع مزايا الخدمة الاساسية، بالإضافة إلى:"
        : text === "Include:"
        ? "تشمل:"
        : text;
    } else return text;
  };
  return (
    <div className="price-card-wrapper">
      <div className={`${isActive ? "active-bg-container " : "inactive-bg-container "} mb-5`}></div>
      <div className="p-5">
        <p className="heading text-center mt-5">{!isActive ? translateText("Basic Service (Free)") : translateText("User Management Service")}</p>
        <p className={`title text-center ${selectedLanguage === "arabic" ? "rtl" : "ltr"}`}>
          {isActive ? translateText("Suitable for small and medium enterprises.") : translateText("Suitable for micro-enterprises.")}
        </p>
        <div
          className={`d-flex align-items-center  ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"}`}
          style={{ gap: ".5rem", marginTop: "4.5rem", marginBottom: "2.5rem" }}
        >
          <div className={`${isActive ? "price-text" : "price-text-inactive"}`}>
            {" "}
            {monthly && isActive ? "19" : !monthly && isActive ? "190" : "0"}
          </div>
          <img src={isActive ? activeCurrency : inactiveCurrency} alt="currency" />
          <div className="muted-text">{monthly ? translateText("per user, per month") : translateText("per user, per year")}</div>
        </div>
        <p className={`details  ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"}`}>
          {isActive ? translateText("Includes all the benefits of the basic service, in addition:") : translateText("Include:")}
        </p>
        <div className={`pb-5 ${selectedLanguage === "arabic" ? "rtl text-right" : "ltr text-left"}`}>
          {isActive
            ? subscribedPoints?.map((item, index) => {
                return (
                  <>
                    <div key={index} className="d-flex align-items-baseline">
                      <img src={tickIcon} alt="tick" />
                      <p className="my-md-3 my-1 mx-3 points">{item?.label}</p>
                    </div>
                  </>
                );
              })
            : freePoints?.map((item, index) => {
                return (
                  <>
                    <div key={index} className="d-flex align-items-baseline">
                      <img src={tickIcon} alt="tick" />
                      <p className="my-md-3 my-1 mx-3 points">{item?.label}</p>
                    </div>
                  </>
                );
              })}
        </div>
      </div>
    </div>
  );
}

export default PriceCard;
